import { createFileRoute } from '@tanstack/react-router'

import { CoreSkillsAssessmentStepPollStatic } from '@/core-skills-assessment/components/CoreSkillsAssessmentStepPollStatic/CoreSkillsAssessmentStepPollStatic'

export const Route = createFileRoute('/skills-assessment/poll-static')({
  component: CoreSkillsAssessmentStepPollStatic,
})
